import { createAction } from '@reduxjs/toolkit';

export const toggleModalAction = createAction('modal/toggleModal');
